import { cn } from '~/lib/cn';

export interface FlexRowProps
  extends React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >,
    React.PropsWithChildren {
  className?: string;
}

export function FlexRow({ className = '', children, ...rest }: FlexRowProps) {
  return (
    <div className={cn('flex', className)} {...rest}>
      {children}
    </div>
  );
}

FlexRow.displayName = 'FlexRow';
